export enum ModalId {
  AddCoApplicant,
  AppraisalRefresh,
  GeicoDiscount,
  MoreDetails,
  SampleTerms,
  SaveSearch,
  SearchBar,
  Shipping,
  SoftPull
}

export enum NativeModalId {
  SoftPull = 'softPull'
}

export const ModalPriorities = {
  [ModalId.AppraisalRefresh]: 1,
  [ModalId.GeicoDiscount]: 2,
  [ModalId.MoreDetails]: 1,
  [ModalId.SampleTerms]: 2,
  [ModalId.SaveSearch]: 1,
  [ModalId.Shipping]: 2,
  [ModalId.SoftPull]: 2
};
